import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useNameCounts } from './NameCounts'
import WordCloud from '@/util/WordCloud.vue'

const topCount = 100


export default /*#__PURE__*/_defineComponent({
  __name: 'NameCloud',
  props: {
    width: {},
    height: {},
    selectMode: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const nameCounts = useNameCounts()

const topNamesRef = computed(() => (nameCounts.nameCounts.get('s')?.slice(0, topCount) ?? [])
  .map(n => ({ text: n.value, size: n.count })))

function onWordClick(word: string) {
  alert(word)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WordCloud, {
    words: topNamesRef.value,
    width: _ctx.width,
    height: _ctx.height,
    "select-mode": _ctx.selectMode,
    onClick: onWordClick
  }, null, 8, ["words", "width", "height", "select-mode"]))
}
}

})